var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeEscalation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 22.06,
    x2: 25.94,
    y1: 24.877,
    y2: 24.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    fill: "#ffadc8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    fill: "#e72636"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e72636",
      fillOpacity: 1
    },
    fill: "url(#a)",
    d: "M24.011 33.877c-.565 0-1.032-.171-1.399-.514a1.64 1.64 0 0 1-.551-1.246c0-.509.185-.926.557-1.251.371-.325.836-.487 1.394-.487.565 0 1.029.164 1.389.493.361.329.541.744.541 1.246 0 .509-.178.929-.535 1.261-.359.331-.824.498-1.396.498zm1.717-17.337-.373 11.743a.642.642 0 0 1-.642.622h-1.468a.642.642 0 0 1-.642-.623l-.353-11.743a.64.64 0 0 1 .642-.662h2.193c.363 0 .654.3.643.663z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeEscalation);
export default __webpack_public_path__ + "static/media/noticeTypeEscalation.ca52d1134831c56e7c7c68725fd6ddf0.svg";
export { ForwardRef as ReactComponent };